import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { DISPLAY_LANG } from '../../../config';
import JSZip from "jszip";
import { saveAs } from "file-saver";
import Loading from "../../../components/loading";
import axios from "../../../axios";
import "../../../stylesheets/ssl-sold-single.css";

export default function SoldSSLSingle() {
  const userId = localStorage.getItem("user_id");
  const [sslSingle, setSslSingle] = useState(null);
  const [sslOrderStatus, setSslOrderStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [downloading, setDownloading] = useState(false);

  const { id } = useParams();

  useEffect(() => {
    loadingData();
  }, [userId]);

  const loadingData = async () => {
    setLoading(true);

    try {
      const resSSLSingle = await axios.get(`users/get-sold-ssl-by-user-id/${userId}`);
      const sslData = resSSLSingle.data.find((ssl) => ssl.id === parseInt(id));
      setSslSingle(sslData);

      const resSSLOrderStatus = await axios.post("ssl/order-status", {
        the_ssl_store_order_id: sslData.the_ssl_store_order_id,
        custom_order_id: sslData.custom_order_id,
      });

      setSslOrderStatus(resSSLOrderStatus.data);
    } catch (err) {
      console.error("FETCH SOLD SSLS ERROR:", err);
      alert("Error fetching SSL data. Please try again later.");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const getMajorStatus = () => {
    if (!sslOrderStatus) return "Unknown";
    if (typeof sslOrderStatus.OrderStatus === "string") return sslOrderStatus.OrderStatus;
    return sslOrderStatus.OrderStatus?.MajorStatus || "Unknown";
  };

  const detailsRows = sslOrderStatus ? [
    {
      label: "Admin Contact",
      value: sslOrderStatus.AdminContact
        ? `${sslOrderStatus.AdminContact.FirstName || ""} ${sslOrderStatus.AdminContact.LastName || ""}`.trim() +
        `\n${sslOrderStatus.AdminContact.Email || ""}` +
        `\n${sslOrderStatus.AdminContact.Phone || ""}`
        : "-",
    },
    { label: "Approver Email", value: sslOrderStatus.ApproverEmail || "-" },
    { label: "Common Name", value: sslOrderStatus.CommonName || "-" },
    { label: "Country", value: sslOrderStatus.Country || "-" },
    { label: "Organization", value: sslOrderStatus.Organization || "-" },
    { label: "Product Name", value: sslOrderStatus.ProductName || "-" },
    { label: "Purchase Date", value: sslOrderStatus.PurchaseDate || "-" },
    { label: "State", value: sslOrderStatus.State || "-" },
    { label: "TSS Organization ID", value: sslOrderStatus.TSSOrganizationId || "-" },
    { label: "The SSL Store Order ID", value: sslOrderStatus.TheSSLStoreOrderID || "-" },
  ] : [];

  const downloadSertificate = async () => {
    if (!sslOrderStatus?.TheSSLStoreOrderID) {
      alert("Order ID not available for download.");
      return;
    }

    setDownloading(true);

    try {
      const res = await axios.post(
        "ssl/download-certificate",
        {
          ssl_store_order_id: sslOrderStatus.TheSSLStoreOrderID,
        }
      );

      const certs = res?.data?.Certificates || [];

      if (!certs.length) {
        alert("No certificates returned from server.");
        return;
      }

      const zip = new JSZip();

      certs.forEach((cert, idx) => {
        const content = cert.FileContent || cert.fileContent || "";
        const filename =
          cert.FileName ||
          cert.fileName ||
          `certificate-${idx + 1}.crt`;

        zip.file(filename, content);
      });

      const zipBlob = await zip.generateAsync({
        type: "blob",
      });

      saveAs(zipBlob, "ssl-certificates.zip");
    } catch (err) {
      console.error("DOWNLOAD CERTIFICATE ERROR:", err);
      alert("Failed to download certificate. Please try again.");
    } finally {
      setDownloading(false);
    }
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="SoldSSLSinglePage wrapper">
      <h1>SSL Order Status</h1>

      {sslOrderStatus && (
        <div className="status-container">
          <div className="status-summary">
            <div className="left">
              <span className="status-label">SSL Status</span>
              <strong className="status-value">{getMajorStatus()}</strong>
            </div>

            <div className="right">
              <button onClick={loadingData} title="Refresh status">
                <img src="/images/ssl/arrows-rotate-solid-full.svg" alt="arrows-rotate-solid-full.svg" />
              </button>

              {sslOrderStatus.OrderStatus?.MajorStatus === 'Active' && (
                <button onClick={downloadSertificate} disabled={downloading} title="Download certificate">
                  <img src="/images/ssl/download-solid-full.svg" alt="download-solid-full.svg" />
                </button>
              )}
            </div>
          </div>

          <div className="status-info">
            <h2>Order Details</h2>
            <div className="details-table-wrapper">
              <table className="details-table">
                <tbody>
                  {detailsRows.map((row, index) => (
                    <tr key={index}>
                      <td className="details-label">{row.label}</td>
                      <td className="details-value">
                        {typeof row.value === "string"
                          ? row.value.split("\n").map((line, idx, arr) => (
                            <span key={idx}>
                              {line}
                              {idx < arr.length - 1 && <br />}
                            </span>
                          ))
                          : String(row.value)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
